import './main.css';

// import './css/cookieconsent/cookieconsent.min.css';
import './js/cookieconsent/cookieconsent.js';
import './js/cookies.js';

import './js/alpine.js';
import './js/ta-gallery-next.js';

import Alpine from 'alpinejs';

// import taGallery from '@markusantonwolf/ta-gallery/dist/js/ta-gallery-next';

import intersect from '@alpinejs/intersect';
Alpine.plugin(intersect);

window.Alpine = Alpine;
Alpine.start();

